import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d320Api, QueryParams, ReportRow, VendorCount } from '../../../services/d320Api';

export function useD320Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [groupCounts, setGroupCounts] = useState<VendorCount[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d320Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setGroupCounts(resp.group_counts || []);
        setNoData(false);
      } else {
        setData([]);
        setGroupCounts([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setGroupCounts([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, groupCounts, queried, noData, runQuery, reset };
}
